export const EVENT_DETAILS_FIELDS_BY_CATEGORY = {
  process: [
    'tgt.process.displayName',
    'src.process.signedStatus',
    'src.process.publisher',
    'tgt.process.cmdline',
    'tgt.process.name',
    'tgt.process.uid',
    'src.process.uid',
    'src.process.image.path',
    'src.process.integrityLevel',
    'src.process.cmdline',
  ],
  cross_process: [
    'tgt.process.displayName',
    'tgt.process.cmdline',
    'tgt.process.name',
    'tgt.process.uid',
    'tgt.process.relation',
  ],
  command_script: [
    'cmdScript.originalSize',
    'cmdScript.isComplete',
    'src.process.image.path',
    'cmdScript.content',
    'cmdScript.applicationName',
    'src.process.cmdline',
  ],
  ip: [
    'event.network.direction',
    'event.network.connectionStatus',
    'src.ip.address',
    'src.port.number',
    'dst.ip.address',
    'dst.port.number',
  ],
  file: ['src.process.signedStatus', 'src.process.publisher', 'tgt.file.size', 'tgt.file.path', 'tgt.file.type'],
  logins: [
    'event.login.userName',
    'event.login.isAdministratorEquivalent',
    'src.endpoint.ip.address',
    'event.login.failureReason',
    'event.login.type',
    'event.login.baseType',
    'event.login.loginIsSuccessful',
  ],
  url: ['url.address', 'event.url.action'],
  dns: ['event.dns.request', 'event.dns.response', 'event.externalLink'],
  scheduled_task: ['task.path', 'task.name'],
  registry: [
    'registry.valueIsComplete',
    'registry.oldValueType',
    'registry.valueType',
    'registry.keyUid',
    'registry.oldValue',
    'registry.value',
    'registry.oldValueFullSize',
    'registry.keyPath',
    'registry.valueFullSize',
    'registry.oldValueIsComplete',
  ],
  indicators: ['indicator.description', 'indicator.category', 'indicator.name', 'indicator.metadata'],
  module: ['module.path', 'module.sha1'],
  // 'firmware': ['']
  threat_intelligence_indicators: [
    'tiIndicator.source',
    'tiIndicator.name',
    'tiIndicator.creationTime',
    'tiIndicator.value',
  ],
  //'named_pipe': ['']
};
